import React from "react";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

export default function ProjectAudioFileComponent(props) {
    return (
        <>
            {props.file && (
                <div
                    style={{
                        width: "100%",
                        maxWidth: props.contentWidth,
                        margin: "0 auto",
                        overflow: "hidden",
                        borderRadius: 12,
                    }}
                >
                    <AudioPlayer autoPlay={false} src={props.file.url} />
                </div>
            )}
        </>
    );
}
